import React, { Fragment } from 'react'
import { GlobalStyle, ContentLayout, LayoutKora } from './styles/GlobalStyles';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Router } from '@reach/router';
import 'antd/dist/antd.min.css';
import GlobalFonts from './fonts/fonts';
import { Affix } from 'antd';

import { Home } from './pages/Home';
import { Blog } from './pages/Blog';
import { Preguntas } from './pages/Preguntas';
import { Productos } from './pages/Productos';
import { SobreNosotros } from './pages/SobreNosotros';
import { ScrollToTop } from './hooks/ScrollToTop';

export const App = () => {
  
  return (
    <Fragment>
      <GlobalFonts />
      <GlobalStyle />
      <Affix style={{ top: 0, left: 0 }}>
        <Header />
      </Affix>
        <LayoutKora >
          <ContentLayout>
            <Router primary={false}>
              <ScrollToTop path="/">
                <Home path='/' />
                <Productos path='/productos' />
                <Productos path='/productos/lineas/:linea' />
                <SobreNosotros path='/nosotros' />
                <Blog path='/blog' />
                <Preguntas path='/preguntas' />
              </ScrollToTop>
            </Router>  
          </ContentLayout>
        </LayoutKora>
      <Footer />
    </Fragment>
  );
}

export default App;
